import React from 'react';
import { InputField } from '@trp-beacon-ui-kit/react-controls';
import SectionHeading from '../Typography/SectionHeading/SectionHeading';
import {
  toDollarAmountOrDash,
  contribInvestmentAmtText
} from '../FONASUCustomerInformation/util';
import styles from '../FONASUCustomerInformationSection/FONASUCustomerInformationSection.css';
import { currentYear, priorYear } from '../../flows/shared/dateUtils';

import {
  MIN_CONTRIBUTION_ERR_MSG,
  CONTRIBUTORY_EXCEEDS_INV_ERR_MSG
} from '../../flows/shared/testers';

const FONASUContribInvestmentAmount = ({
  formProps,
  handleCurrentYearAmt,
  handlePriorYearAmt,
  totalInvestmentAmt,
  priorYearInvAmount,
  curYearInvAmount,
  contributionLimits,
  meetsMinInvestmentAmt,
  exceedsContribAmt
}) => {
  const {
    currentYearMaximumLimit,
    currentYearContributionsSoFar,
    currentYearRemainingContributions,
    priorYearMaximumLimit,
    priorYearContributionsSoFar,
    priorYearRemainingContributions,
    withinIRAPriorYearContributionPeriod
  } = contributionLimits;

  const onKeyDown = event => {
    if (['.', '-'].includes(event.key)) event.preventDefault();
  };

  return (
    <>
      <div className="qv-row investment-heading">
        <SectionHeading text="Investment Amount" />
      </div>
      {withinIRAPriorYearContributionPeriod && (
        <div className="qv-row">
          <div className="qv-col">
            <div className="field-label">
              {priorYear} IRA Contribution Limit
            </div>
            <div className="field-value">
              {toDollarAmountOrDash(priorYearMaximumLimit)}
            </div>
          </div>
          <div className="qv-col">
            <div className="field-label">Your contribution to date*</div>
            <div className="field-value">
              {toDollarAmountOrDash(priorYearContributionsSoFar)}
            </div>
          </div>
          <div className="qv-col">
            <div className="field-label">Contribution amount remaining</div>
            <div className="field-value">
              {toDollarAmountOrDash(priorYearRemainingContributions)}
            </div>
          </div>
          <div className="qv-col">
            <InputField
              type="number"
              maxLength="12"
              {...formProps.priorYearAmount}
              defaultValue={priorYearInvAmount}
              placeholder="$0"
              title={`${priorYear} IRA Contributions`}
              onKeyDown={onKeyDown}
              onChange={handlePriorYearAmt}
            />
          </div>
        </div>
      )}
      <div className="qv-row">
        <div className="qv-col">
          <div className="field-label">
            {currentYear()} IRA Contribution Limit
          </div>
          <div className="field-value">
            {toDollarAmountOrDash(currentYearMaximumLimit)}
          </div>
        </div>
        <div className="qv-col">
          <div className="field-label">Your contribution to date*</div>
          <div className="field-value">
            {toDollarAmountOrDash(currentYearContributionsSoFar)}
          </div>
        </div>
        <div className="qv-col">
          <div className="field-label">Contribution amount remaining</div>
          <div className="field-value">
            {toDollarAmountOrDash(currentYearRemainingContributions)}
          </div>
        </div>
        <div className="qv-col">
          <InputField
            type="number"
            maxLength="12"
            {...formProps.currentYearAmount}
            defaultValue={curYearInvAmount}
            placeholder="$0"
            title={`${currentYear()} IRA Contributions`}
            onKeyDown={onKeyDown}
            onChange={handleCurrentYearAmt}
          />
        </div>
      </div>
      {meetsMinInvestmentAmt && (
        <div className="contribution-error-message">
          {MIN_CONTRIBUTION_ERR_MSG}
        </div>
      )}
      {exceedsContribAmt && (
        <div className="contribution-error-message">
          {CONTRIBUTORY_EXCEEDS_INV_ERR_MSG}
        </div>
      )}

      <div className="qv-row">
        <div className="qv-col">{contribInvestmentAmtText}</div>
        {withinIRAPriorYearContributionPeriod && (
          <div className="qv-col">
            <div className="field-label">New Investment Amount Total </div>
            <div className="field-value">
              ${Number(totalInvestmentAmt).toLocaleString('en-US')}
            </div>
          </div>
        )}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default FONASUContribInvestmentAmount;
